module.exports = __webpack_public_path__ + "static/media/ToGoScreen.1a21ef28.png";